module.exports = __webpack_public_path__ + "img/growcify-dashboard-banner-5.943a36ab.png";